export default __webpack_public_path__ + "static/media/Users.48049949.svg";